/**
 * Defers the name index engine (~15 KB) to the first search gesture, its URL
 * read from data-src since an asset cannot run Liquid. The "/" shortcut and the
 * field focus stay eager, being small enough to ship on every page.
 */
(function () {
  const me = document.currentScript;
  if (!me || window.bqHeaderSearchLazy) return;
  window.bqHeaderSearchLazy = true;
  const src = me.dataset.src;
  if (!src) return;

  const TRIGGERS = ['focusin', 'pointerdown', 'pointerenter'];
  const OPENERS = 'predictive-search-component, .search-action, .bq-search-trigger, #search-modal';
  let el = null;

  function load() {
    if (el) return;
    el = document.createElement('script');
    el.src = src;
    el.addEventListener('load', () => {
      const active = document.activeElement;
      if (active && active.closest && active.closest('predictive-search-component')) {
        active.dispatchEvent(new FocusEvent('focusin', { bubbles: true }));
      }
    });
    document.head.appendChild(el);
    TRIGGERS.forEach((t) => document.removeEventListener(t, onHit, true));
  }

  function onHit(e) {
    if (!(e.target instanceof Element)) return;
    if (!e.target.closest(OPENERS)) return;
    load();
  }

  TRIGGERS.forEach((t) => document.addEventListener(t, onHit, true));

  const modal = document.getElementById('search-modal');

  // DialogOpenEvent does not bubble, so it is caught on the component itself.
  if (modal) {
    modal.addEventListener('dialog:open', () => {
      const field = modal.querySelector('input[type="search"]');
      if (field) field.focus();
    });
  }

  // "/" opens the layer, ignored while typing or while a modifier is held.
  document.addEventListener('keydown', (e) => {
    if (e.key !== '/' || e.metaKey || e.ctrlKey || e.altKey || e.isComposing) return;
    const active = document.activeElement;
    if (active && (active.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName))) return;
    if (!modal || (modal.querySelector('dialog') || {}).open) return;
    e.preventDefault();
    load();
    if (typeof modal.showDialog === 'function') modal.showDialog();
    else {
      const dlg = modal.querySelector('dialog');
      if (dlg && typeof dlg.showModal === 'function') dlg.showModal();
    }
  });

  // Deferred, so a focus landing before this runs leaves no event to catch; the
  // field is checked once on arrival.
  const active = document.activeElement;
  if (active && active.closest && active.closest(OPENERS)) load();
})();
